import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';
import { useLanguage } from '../../hooks/useLanguage';

const PrivacyPolicy: React.FC = () => {
    const { t, isRTL } = useLanguage();

    return (
        <LegalPageTemplate
            title={t('privacyPolicy.title')}
            lastUpdated={t('privacyPolicy.lastUpdated')}
        >
            <div dir={isRTL ? 'rtl' : 'ltr'}>
                <p className={`text-gray-600 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.intro.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.intro.paragraph2')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section1.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section1.intro')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section1.company.name')}<br />
                    {t('privacyPolicy.section1.company.address')}<br />
                    {t('privacyPolicy.section1.company.email')}<br />
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section2.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section2.intro')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section2.subsection1.title')}
                </h3>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section2.subsection1.items.name')}</li>
                    <li>{t('privacyPolicy.section2.subsection1.items.email')}</li>
                    <li>{t('privacyPolicy.section2.subsection1.items.phone')}</li>
                    <li>{t('privacyPolicy.section2.subsection1.items.position')}</li>
                    <li>{t('privacyPolicy.section2.subsection1.items.company')}</li>
                    <li>{t('privacyPolicy.section2.subsection1.items.siret')}</li>
                </ul>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section2.subsection2.title')}
                </h3>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section2.subsection2.items.credentials')}</li>
                    <li>{t('privacyPolicy.section2.subsection2.items.ip')}</li>
                    <li>{t('privacyPolicy.section2.subsection2.items.datetime')}</li>
                    <li>{t('privacyPolicy.section2.subsection2.items.pages')}</li>
                    <li>{t('privacyPolicy.section2.subsection2.items.browser')}</li>
                </ul>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section2.subsection3.title')}
                </h3>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section2.subsection3.items.inspections')}</li>
                    <li>{t('privacyPolicy.section2.subsection3.items.vehicles')}</li>
                    <li>{t('privacyPolicy.section2.subsection3.items.communications')}</li>
                    <li>{t('privacyPolicy.section2.subsection3.items.billing')}</li>
                </ul>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section2.subsection4.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section2.subsection4.description')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section3.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section3.intro')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section3.subsection1.title')}
                </h3>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section3.subsection1.items.account')}</li>
                    <li>{t('privacyPolicy.section3.subsection1.items.services')}</li>
                    <li>{t('privacyPolicy.section3.subsection1.items.payment')}</li>
                    <li>{t('privacyPolicy.section3.subsection1.items.support')}</li>
                </ul>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section3.subsection2.title')}
                </h3>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section3.subsection2.items.improvement')}</li>
                    <li>{t('privacyPolicy.section3.subsection2.items.analytics')}</li>
                    <li>{t('privacyPolicy.section3.subsection2.items.fraud')}</li>
                    <li>{t('privacyPolicy.section3.subsection2.items.communication')}</li>
                </ul>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section3.subsection3.title')}
                </h3>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section3.subsection3.items.marketing')}</li>
                    <li>{t('privacyPolicy.section3.subsection3.items.usage')}</li>
                </ul>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section3.subsection4.title')}
                </h3>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section3.subsection4.items.legal')}</li>
                    <li>{t('privacyPolicy.section3.subsection4.items.authorities')}</li>
                </ul>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section4.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section4.intro')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li><strong>{t('privacyPolicy.section4.items.account.title')}</strong> {t('privacyPolicy.section4.items.account.duration')}</li>
                    <li><strong>{t('privacyPolicy.section4.items.billing.title')}</strong> {t('privacyPolicy.section4.items.billing.duration')}</li>
                    <li><strong>{t('privacyPolicy.section4.items.connection.title')}</strong> {t('privacyPolicy.section4.items.connection.duration')}</li>
                    <li><strong>{t('privacyPolicy.section4.items.inspections.title')}</strong> {t('privacyPolicy.section4.items.inspections.duration')}</li>
                </ul>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section4.conclusion')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section5.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section5.intro')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li><strong>{t('privacyPolicy.section5.rights.access.title')}</strong> {t('privacyPolicy.section5.rights.access.description')}</li>
                    <li><strong>{t('privacyPolicy.section5.rights.rectification.title')}</strong> {t('privacyPolicy.section5.rights.rectification.description')}</li>
                    <li><strong>{t('privacyPolicy.section5.rights.erasure.title')}</strong> {t('privacyPolicy.section5.rights.erasure.description')}</li>
                    <li><strong>{t('privacyPolicy.section5.rights.limitation.title')}</strong> {t('privacyPolicy.section5.rights.limitation.description')}</li>
                    <li><strong>{t('privacyPolicy.section5.rights.portability.title')}</strong> {t('privacyPolicy.section5.rights.portability.description')}</li>
                    <li><strong>{t('privacyPolicy.section5.rights.opposition.title')}</strong> {t('privacyPolicy.section5.rights.opposition.description')}</li>
                    <li><strong>{t('privacyPolicy.section5.rights.consent.title')}</strong> {t('privacyPolicy.section5.rights.consent.description')}</li>
                    <li><strong>{t('privacyPolicy.section5.rights.posthumous.description')}</strong></li>
                </ul>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section5.contact')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section5.cnil')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section6.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section6.intro')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section6.items.teams')}</li>
                    <li>{t('privacyPolicy.section6.items.subcontractors')}</li>
                    <li>{t('privacyPolicy.section6.items.authorities')}</li>
                </ul>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section6.conclusion')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section7.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section7.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section7.paragraph2')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section7.items.adequacy')}</li>
                    <li>{t('privacyPolicy.section7.items.clauses')}</li>
                    <li>{t('privacyPolicy.section7.items.rules')}</li>
                </ul>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section8.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section8.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section8.paragraph2')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section8.items.encryption')}</li>
                    <li>{t('privacyPolicy.section8.items.authentication')}</li>
                    <li>{t('privacyPolicy.section8.items.firewall')}</li>
                    <li>{t('privacyPolicy.section8.items.audits')}</li>
                    <li>{t('privacyPolicy.section8.items.training')}</li>
                </ul>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section9.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section9.text')} <a href="/cookie-policy" className="text-[#115DF2] hover:underline">{t('privacyPolicy.section9.linkText')}</a>.
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section10.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section10.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section10.paragraph2')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section11.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('privacyPolicy.section11.intro')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('privacyPolicy.section11.email')}</li>
                </ul>
            </div>
        </LegalPageTemplate>
    );
};

export default PrivacyPolicy;